import request from "@/request/request";
import request2 from "@/request/request_py";
import axios from "axios";
const http = {
    async get(url, params) {
        const config = {
            method: 'get', url: url
        }
        if (params) {
            config.params = params
        }
        return await this.cus_request(config);

    },

    async post(url, data) {
        const config = {
            method: 'post', url: url,
        }
        if (data) config.data = data
        return await this.cus_request(config)
    },

    async postFile(url, data) {
        // const config = {
        //     method: 'post', url: url
        // }
        // const formData = new FormData();
        // formData.append('file', data);
        // config.data = formData;
        // let res = await request2(config);
        // if (res && res.code === 500) {
        //     throw res.msg
        // } else {
        //     return res
        // }
        const formData = new FormData();
        formData.append('file', data);

        await axios.post('/pyUrl/detect', formData);
    },

    /**
     * post请求文件
     * @param url
     * @param data
     * @returns {Promise<any|undefined>}
     */
    async getFile(url, data) {
        const config = {
            method: 'post', url: url, responseType: 'blob'
        }

        if (data) config.data = data
        let res = await request(config);
        if (res && res.code === 500) {
            throw res.msg
        } else {
            return res
        }
    },

    async downLoad(url) {
        const config = {
            method: 'get', url: url, type: 'multipart/form-data'
        }
        return await request(config)
    },

    async put(url, data) {
        const config = {
            method: 'put', url: url
        }
        if (data) config.data = data
        return await this.cus_request(config);
    },

    async delete(url, params) {
        const config = {
            method: 'delete', url: url
        }
        if (params) {
            config.params = params
        }
        return await this.cus_request(config);
    },

    async cus_request(config) {
        let res = await request(config);
        if (res.code === 200) {
            return res.data;
        } else {
            throw res.msg
        }
    }
}

export default http
